import React from 'react';
import DecisionFactorsTemplate from '../decisionFactorsTemplate/DecisionFactorsTemplate';

const pageTitle = 'Effortless Recovery';
const pageSubTitle = 'Effortless Recovery';
const videoKey = 'PCQz8t7buqM';

const EffortlessRecovery = () => {

    return (
        <DecisionFactorsTemplate
            pageTitle={pageTitle}
            pageSubTitle={pageSubTitle}
            videoKey={videoKey}
            pageDescription={
                <p>
                    Effortless Recovery reflects how important it is for the healing process to feel
                    manageable and not overly demanding. This includes avoiding treatments that require
                    a lot of energy, stress, or complicated care during recovery.
                    <br/>
                    For example:
                    <br/>
                    <ul style={{ marginLeft: 16 }}>
                        <li>
                            Total Knee Replacement usually requires significant effort during healing.
                        </li>
                        <li>
                            NSAIDs are minimal-effort.
                        </li>
                        <li>
                            Injections—like PRP, Cortisone, and Hyaluronic Acid—and Physical Therapy
                            fall in the moderate-effort range.
                        </li>
                    </ul>
                    <br/>
                    This criterion helps identify treatments that offer a smoother, less burdensome path
                    to recovery.
                </p>
            }
            pageType="criteria"
        />
    );
};

export default EffortlessRecovery;